export default __webpack_public_path__ + "static/media/ema.a3d79dc8.jpg";